import React from "react";

import Home from "../../pages/home/Home.jsx";

import lazyPages from "../lazy-loading/index.js";

// <lazyPages.listing/> is same as

// const Listing = React.lazy(() => import("../../pages/property-listing/Propertylisting.jsx")
// and then using <Listing/> inside the element

// little bit vired but it works

const globalRoutes = [
  { path: "", element: <Home /> },
  { path: "properties", element: <lazyPages.listing /> },
  {
    path: ":country/destinations/:destination/:propertyType?",
    element: <lazyPages.DestinationListing />,
  },
  {
    path: "properties/:propertyId/:propertyName?",
    element: <lazyPages.singleProperty />,
  },
  {
    path: "property/:propertyId/:propertyName?",
    element: <lazyPages.singleProperty />,
  },

  {
    path: "signin",
    element: <lazyPages.Signin />,
    exact: true,
  },
  {
    path: "signin-password",
    element: <lazyPages.Signin />,
    exact: true,
  },
  {
    path: "signup",
    element: <lazyPages.Signup />,
    exact: true,
  },
  {
    path: "create-account",
    element: <lazyPages.CreateAccount />,
    exact: true,
  },
  {
    path: "create-password",
    element: <lazyPages.CreatePassword />,
    exact: true,
  },
  {
    path: "forgot-password",
    element: <lazyPages.ForgotPassword />,
    exact: true,
  },
  {
    path: "reset-password",
    element: <lazyPages.ResetPassword />,
    exact: true,
  },
  {
    path: "auth/success",
    element: <lazyPages.AuthSuccess />,
    exact: true,
  },
  {
    path: "auth/failure",
    element: <lazyPages.AuthFailure />,
    exact: true,
  },
  {
    path: "message-form",
    element: <lazyPages.MessageForm />,
    exact: true,
  },

  {
    path: "privacy-policy",
    element: <lazyPages.PrivacyPolicy />,
    exact: true,
  },
  {
    path: "terms-and-conditions",
    element: <lazyPages.TermsConditions />,
    exact: true,
  },
  {
    path: "cookie-policy",
    element: <lazyPages.CookiePolicy />,
    exact: true,
  },
  {
    path: "/privacy/dsar-form",
    element: <lazyPages.DSARForm />,
    exact: true,
  },
  {
    path: "disclaimer",
    element: <lazyPages.Disclaimer />,
    exact: true,
  },

  {
    path: "acceptable-use-policy",
    element: <lazyPages.AcceptableUsePolicy />,
    exact: true,
  },

  {
    path: "not-found",
    element: <lazyPages.NotFound />,
    exact: true,
  },
  {
    path: "google-map",
    element: <lazyPages.GoogleMap />,
    exact: true,
  },

  {
    path: "mobile/payment/initialize",
    element: <lazyPages.MobilePaymentIntialization />,
  },
];

export default globalRoutes;
